import { Link, Tooltip } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";

import { PortalContainerContext } from "@/contexts";

type CarbonIntensityProps = {
  text: string;
  href: string;
};

function PedagogicLink({ text, href }: CarbonIntensityProps) {
  const { t } = useTranslation();
  const { container } = use(PortalContainerContext);

  return (
    <Tooltip
      portalContainer={container as Element}
      content={t("help_center")}
      side="top"
    >
      <Link href={href} shouldOpenNewTab>
        {text}
      </Link>
    </Tooltip>
  );
}

export default PedagogicLink;
